<template>
<div class="chapter">
<div class="inner_page">
<p class="toc2"><span><b>CONTENTS</b></span></p>
<p class="toc2"><a href="#/Book1/xhtml/cover">FIFTY DAYS OF SOLITUDE</a></p>
<p class="toc2"><span href="#/Book2/xhtml/cover" title="Link target outside of Sample">THE PLEASURE OF THEIR COMPANY</span></p>
<p class="toc2"><span href="#/Book3/xhtml/cover" title="Link target outside of Sample">EXTRA INNINGS</span></p>
<p class="toc1"><span href="#/Book3/xhtml/part1" title="Link target outside of Sample">September</span></p>
<p class="toc1"><span href="#/Book3/xhtml/part2" title="Link target outside of Sample">October</span></p>
<p class="toc1"><span href="#/Book3/xhtml/part3" title="Link target outside of Sample">November</span></p>
<p class="toc1"><span href="#/Book3/xhtml/part4" title="Link target outside of Sample">December</span></p>
<p class="toc1"><span href="#/Book3/xhtml/part5" title="Link target outside of Sample">January</span></p>
<p class="toc1"><span href="#/Book3/xhtml/part6" title="Link target outside of Sample">February</span></p>
<p class="toc1"><span href="#/Book3/xhtml/part7" title="Link target outside of Sample">March</span></p>
<p class="toc1"><span href="#/Book3/xhtml/part8" title="Link target outside of Sample">April</span></p>
<p class="toc1"><span href="#/Book3/xhtml/part9" title="Link target outside of Sample">May</span></p>
<p class="toc1"><span href="#/Book3/xhtml/part10" title="Link target outside of Sample">Summer</span></p>
<p class="toc2"><span href="#/Comon/backmatter01" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bundle_content.vue?1ce4416d